import * as React from "react";
import { IconNames } from "@blueprintjs/icons";
import { ETLCodes } from "../../locales";
import { useTl } from "../../hooks";
import { Intent, Button } from "@blueprintjs/core";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface IFusionButtonProps extends ICustomButtonProps {}

export const FusionButton: React.FunctionComponent<IFusionButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY,
  text,
}) => {
  const { t } = useTl();
  return (
    <Button
      icon={IconNames.GROUP_OBJECTS}
      minimal={minimal}
      onClick={onClick}
      text={text || (minimal ? null : t(ETLCodes.General_Group))}
      intent={intent}
      loading={loading}
      disabled={disabled}
      type={onClick ? "button" : "submit"}
    />
  );
};
